import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { PublicLayout } from "@/components/PublicLayout";

import Home from "@/pages/Home";
import Mouvement from "@/pages/Mouvement";
import President from "@/pages/President";
import Bureau from "@/pages/Bureau";
import Actualites from "@/pages/Actualites";
import ArticleDetail from "@/pages/ArticleDetail";
import Agenda from "@/pages/Agenda";
import Comites from "@/pages/Comites";
import Contact from "@/pages/Contact";
import Adhesion from "@/pages/Adhesion";
import MentionsLegales from "@/pages/MentionsLegales";
import Verify from "@/pages/Verify";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

import MemberLogin from "@/pages/member/MemberLogin";
import MemberRegister from "@/pages/member/MemberRegister";
import MemberSpace from "@/pages/member/MemberSpace";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/le-mouvement" element={<Mouvement />} />
              <Route path="/le-president" element={<President />} />
              <Route path="/le-bureau" element={<Bureau />} />
              <Route path="/actualites" element={<Actualites />} />
              <Route path="/actualites/:slug" element={<ArticleDetail />} />
              <Route path="/agenda" element={<Agenda />} />
              <Route path="/comites" element={<Comites />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/adhesion" element={<Adhesion />} />
              <Route path="/mentions-legales" element={<MentionsLegales />} />
              <Route path="/verifier/:number" element={<Verify />} />
            </Route>

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />

            <Route path="/espace-membre/connexion" element={<MemberLogin />} />
            <Route path="/espace-membre/inscription" element={<MemberRegister />} />
            <Route
              path="/espace-membre"
              element={
                <ProtectedRoute redirectTo="/espace-membre/connexion" roles={["member", "admin"]}>
                  <MemberSpace />
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
